import React from 'react';
import slug from 'slug';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';

import { ProcedureGallery, ProcedureDesc } from '../components/index';

class Procedure extends React.Component {
  renderVideo = (procedure) => {
    if (procedure.video) {
      return (
        <div className="docDetail_video" style={{marginBottom: 30}}>
          <iframe width="854" height="480" src={"https://www.youtube.com/embed/" + procedure.video}
                  frameBorder="0" allowFullScreen/>
        </div>
      )
    }
    if (procedure.videos) {
      return procedure.videos.map(video => {
        return (<div className="docDetail_video" style={{marginBottom: 30}}>
          <iframe width="854" height="480" src={"https://www.youtube.com/embed/" + video}
                  frameBorder="0" allowFullScreen/>
        </div>)
      });
    }
  };

  render() {
    const langs = this.props.texts.langs;

    const surgery = langs.surgery.find(sur => slug(sur.name, {lower: true}) === this.props.params.surgery);
    const procedure = surgery.procedures.find(proc => slug(proc.name, {lower: true}) === this.props.params.procedure);

    return (
      <div className="procedureSite bc-beige2">
        <div className="siteBanner newBg">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">{procedure.name}</h2>
        </div>
        <ProcedureDesc
          surgeryId={surgery.id}
          procedure={procedure}
        />
        {this.renderVideo(procedure)}
        <ProcedureGallery
          params={this.props.params}
        />
      </div>
    );
  }
}

export default Procedure;



// WEBPACK FOOTER //
// ./src/containers/Procedure.js